import React, { Component } from "react";
import SummaryDetailWithIcon from "../../shared/groups/SummaryDetailWithIcon";
import Contentify from "../../../content/Contentify";
import { connect } from "react-redux";
import Store from "../../../content/Store";
import styles from "../../../assets/css/modules/claims/pay-shortfall.css";
import { sentenceToTitleCase } from "../../../helpers/SentenceToTitleCase";

const payeeHasBankDetails = (payee) =>
  payee.AccountNumber &&
  payee.SortCode &&
  payee.DoesSpecialistAllowBankDetailsDisplayOnline !== false;

export const parsePayeeAddress = (payeeAddress) => {
  if (!payeeAddress.PostCode) {
    return null;
  }
  return Object.keys(payeeAddress).map((key) => {
    let addressLine = payeeAddress[key];
    if (addressLine && addressLine.trim().length > 0) {
      if (key === "PostCode") {
        return (
          <React.Fragment>
            {addressLine.toUpperCase()}
            <br />
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            {sentenceToTitleCase(payeeAddress[key])}
            <br />
          </React.Fragment>
        );
      }
    }
    return null;
  });
};

export const mapStateToHowToPayShortFallSection = (state) => {
  return {
    payee:
      state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails.Payee,
    payeeAddress: parsePayeeAddress(
      state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails.Payee
        .PayeeAddress
    ),
    totalMemberLiabilityAmount:
      state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails
        .TotalMemberLiabilityAmount,
    treatingProviderName: state.claimsReducer.selectedPolicy.selectedInvoice
      .TreatingProviderName
      ? sentenceToTitleCase(
          state.claimsReducer.selectedPolicy.selectedInvoice
            .TreatingProviderName
        )
      : "the provider"
  };
};

const renderBankTransferView = (props) => {
  return (
    <React.Fragment>
      <p className="m-0 mb-1">{props.content.bankTransferDescription(props)}</p>
      <div className="row">
        <div className="col-6">
          <p className="m-0">
            <strong>{props.content.AccountNumberLabel}</strong>
          </p>
          <p>{props.payee.AccountNumber}</p>
        </div>
        <div className="col-6">
          <p className="m-0">
            <strong>{props.content.SortCodeLabel}</strong>
          </p>
          <p>{props.payee.SortCode}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <p className="m-0">
            <strong>{props.content.accountNameLabel}</strong>
          </p>
          <p>{props.payee.Name}</p>
        </div>       
      </div>
    </React.Fragment>
  );
};

export class HowToPayShortFallSection extends Component {
  static content = Store.PaymentDetails.howToPayShortfall;
  render() {
    let summaryDetails = [];
    if (this.props.payee) {
      if (payeeHasBankDetails(this.props.payee)) {
        summaryDetails.push(
          <div
            id="bankDetails"
            key={1}
            className={"col-md-4 col-sm-12 " + styles.mobileCol}
          >
            <SummaryDetailWithIcon
              iconSrc="icon-symbol-pound"
              title={this.props.content.bankTransferTitle}
              info={renderBankTransferView(this.props)}
              styles={styles}
            />
          </div>
        );
      }
      if (this.props.payee.Telephone) {
        summaryDetails.push(
          <div
            id="telephone"
            key={2}
            className={"col-md-4 col-sm-12 " + styles.mobileCol}
          >
            <SummaryDetailWithIcon
              iconSrc="icon-functional-phone"
              title={this.props.content.phoneCreditCardTitle}
              info={this.props.content.phoneCreditCardContent(this.props)}
              styles={styles}
            />
          </div>
        );
      }
      if (
        this.props.payee.PayeeAddress &&
        this.props.payee.PayeeAddress.PostCode
      ) {
        summaryDetails.push(
          <div id="address" key={3} className="col-md-4 col-sm-12">
            <SummaryDetailWithIcon
              iconSrc="icon-functional-inbox"
              title={this.props.content.byPostChequeTitle}
              info={ this.props.payee.Name != null ? this.props.content.byPostChequeContentpayee(this.props) : this.props.content.byPostChequeContent(this.props)}
              styles={styles}
            />
          </div>
        );
      }
    }

    return (
      <div className="row">
        {summaryDetails.length ? (
          <div className="col-12">
            <div className={"col-12 " + styles.sectionBorder} />
          </div>
        ) : null}

        {summaryDetails}
      </div>
    );
  }
}

export default connect(mapStateToHowToPayShortFallSection)(
  Contentify(HowToPayShortFallSection)
);
